import React, { useState } from 'react';
import styles from '../css/FAQ.module.css';

const faqData = [
	{
		question:
			'What makes us the best choice for appliance repairs in Bangalore and Dhanbad?',
		answer:
			'Our appliance repair services in Bangalore and Dhanbad stand out due to our highly trained technicians, prompt service, and affordable pricing. Whether it’s a refrigerator, washing machine, or air conditioner, we specialize in all types of appliance repairs, ensuring your home stays fully operational.',
	},
	{
		question:
			'How can I schedule an appliance repair service in Bangalore or Dhanbad?',
		answer:
			'Scheduling an appliance repair service in Bangalore or Dhanbad is simple! You can book a repair directly through our easy-to-use website, via phone, or by contacting our support team through live chat. We offer flexible appointment slots to suit your schedule, and our technicians will arrive at your doorstep on time.',
	},
	{
		question:
			'Do you offer emergency appliance repair services in Bangalore and Dhanbad?',
		answer:
			'Yes! We offer 24/7 emergency appliance repair services in Bangalore and Dhanbad. Whether your refrigerator stops cooling in the middle of the night or your washing machine breaks down on a holiday, our expert technicians are just a call away to provide immediate solutions and minimize any inconvenience.',
	},
	{
		question:
			'What types of appliances do you repair in Bangalore and Dhanbad?',
		answer:
			'We provide comprehensive repair services for a wide range of home appliances in Bangalore and Dhanbad. Our services include refrigerator repair, washing machine repair, microwave repair, air conditioner servicing, and much more. No matter the brand or model, our technicians have the expertise to fix all types of appliances efficiently.',
	},
	{
		question:
			'How do I know if my appliance can be repaired in Bangalore or Dhanbad?',
		answer:
			'Our technicians in Bangalore and Dhanbad are experienced in diagnosing and repairing a wide variety of appliances. If your appliance is malfunctioning or showing signs of wear, simply contact us for a quick assessment. After inspecting the issue, our experts will let you know if the appliance can be repaired or if a replacement is necessary.',
	},
	{
		question:
			'What should I do if my appliance is not working properly in Bangalore or Dhanbad?',
		answer:
			"If your appliance isn’t working properly in Bangalore or Dhanbad, the first step is to contact us for a repair consultation. Our technicians will quickly diagnose the issue and provide you with an affordable, effective solution. Whether it's a minor repair or a major issue, we’re committed to restoring your appliance as quickly as possible.",
	},
	{
		question:
			'Are the repair parts used in Bangalore and Dhanbad repairs genuine?',
		answer:
			'Yes! We only use genuine, high-quality replacement parts for all our appliance repairs in Bangalore and Dhanbad. Our commitment to using authentic parts ensures that your appliances perform optimally and have a longer lifespan. We work with trusted suppliers to guarantee the best possible service.',
	},
	{
		question:
			'How long will it take to repair my appliance in Bangalore or Dhanbad?',
		answer:
			'Repair times can vary depending on the type and complexity of the appliance issue. However, our skilled technicians in Bangalore and Dhanbad aim to complete most repairs within a few hours to a day. We strive to provide fast and efficient service so you can return to your daily routine as soon as possible.',
	},
	{
		question:
			'What are the benefits of choosing professional appliance repair in Bangalore and Dhanbad?',
		answer:
			'Choosing professional appliance repair services in Bangalore and Dhanbad offers several advantages, including expert diagnosis, fast service, and the use of genuine replacement parts. Our certified technicians ensure that your appliances are repaired to the highest standards, saving you time and money compared to DIY repairs.',
	},
	{
		question:
			'Can I get a free quote for appliance repairs in Bangalore and Dhanbad?',
		answer:
			'Yes, we offer free, no-obligation quotes for appliance repairs in Bangalore and Dhanbad. Simply contact us with details about the issue you’re facing, and we will provide a transparent estimate for the repair cost. We ensure competitive pricing, with no hidden charges.',
	},
	{
		question:
			'Do you provide appliance repair maintenance contracts in Bangalore and Dhanbad?',
		answer:
			'Yes, we offer appliance repair maintenance contracts in Bangalore and Dhanbad. Our maintenance plans are designed to ensure that your appliances run smoothly year-round, preventing costly repairs and extending the lifespan of your home appliances. Contact us today to learn more about our customizable maintenance packages.',
	},
	{
		question:
			'Are your appliance repair services affordable in Bangalore and Dhanbad?',
		answer:
			'Our appliance repair services are known for being both affordable and high-quality in Bangalore and Dhanbad. We offer competitive pricing without compromising on the quality of our repairs. Whether you need a quick fix or a major repair, we provide cost-effective solutions that suit your budget.',
	},
	{
		question:
			'What makes your appliance repair services trustworthy in Bangalore and Dhanbad?',
		answer:
			'Our appliance repair services in Bangalore and Dhanbad are trustworthy due to our experienced technicians, transparent pricing, and commitment to customer satisfaction. We prioritize honesty, quality service, and reliability, ensuring that you receive the best possible experience every time you choose us for your appliance repair needs.',
	},
	{
		question:
			'Do you offer appliance repair warranties in Bangalore and Dhanbad?',
		answer:
			'Yes, we offer warranties on all appliance repairs in Bangalore and Dhanbad. Our warranty covers parts and labor, giving you peace of mind knowing that if any issues arise after the repair, we’ll take care of it at no extra cost. We stand behind our work and strive to provide lasting, dependable repairs.',
	},
];

function FAQ() {
	const [openIndex, setOpenIndex] = useState(null);

	const toggleFAQ = (index) => {
		setOpenIndex(openIndex === index ? null : index);
	};

	return (
		<div className={styles.faqContainer}>
			<h2 className={styles.heading}>Need assistance?</h2>
			<p className={styles.subheading}>
				In this section, you can address common appliance repair questions
				efficiently.
			</p>
			<div className={styles.faqGrid}>
				{faqData.map((item, index) => (
					<div
						key={index}
						className={styles.faqItem}
						onClick={() => toggleFAQ(index)}
					>
						<h3 className={styles.question} style={{ cursor: 'pointer' }}>
							{item.question}
						</h3>
						{openIndex === index && (
							<p className={styles.answer}>{item.answer}</p>
						)}
					</div>
				))}
			</div>
		</div>
	);
}

export default FAQ;
